import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ui-prefix-input',
  templateUrl: './ui-prefix-input.component.html',
  styleUrls: ['./ui-prefix-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPrefixInputComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
})
export class UiPrefixInputComponent implements ControlValueAccessor {
  @Input()
  public prefix?: string;
  @Input()
  public label?: string;
  @Input()
  public icon?: string;
  @Input()
  public placeholder = '';
  @Input()
  public invalid = false;
  @Input()
  public disabled = false;

  @Input()
  public inputType = 'text';
  public value = '';

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(val: string): void {
    this.value = val;
  }

  public updateValue(insideValue: string): void {
    this.value = insideValue;
    this.onChange(insideValue);
    this.onTouched();
  }

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;
}
